import React from 'react';
import FadeIn from 'react-fade-in';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Page from 'src/components/Page';
import MainLayout from 'src/layouts/MainLayout';
import { useTranslation } from 'react-i18next';
import I18nMenu from 'src/layouts/DashboardLayout/I18nMenu';
import Footer from 'src/components/Footer';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import useStyles from 'src/views/auth/styles';

const CardFormSuccessView = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <MainLayout>
      <Page
        className={classes.userVerifictionRoot}
        title={t('OPENPAY_CARD_FORM.SUCCESS.TITLE')}
      >
        <Box display="flex" flexDirection="column" height="100%">
          <div style={{ marginLeft: 'auto' }}>
            <I18nMenu />
          </div>
          <Container className={classes.userVerifictionContainter}>
            <FadeIn transitionDuration={200}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginBottom: '10%'
                }}
              >
                <CheckCircleIcon className={classes.verifiedIcon} />
              </Box>
              <Typography className={classes.verifiedText}>
                {t('OPENPAY_CARD_FORM.SUCCESS.CARD_SAVED')}
              </Typography>
            </FadeIn>
          </Container>
          <Footer />
        </Box>
      </Page>
    </MainLayout>
  );
};

export default CardFormSuccessView;

